import React from 'react';

import cx from 'classnames';

import s from './index.module.css';

function ListItemTitle({ companyName, consultantFirstName, consultantLastName, email }) {
  const name = [consultantFirstName, consultantLastName].join(' ');

  return (
    <div className={s.wrapper}>
      <span className={s.name}>{name || email}</span>
      <span className={cx(s.name, s.companyName)}>({companyName})</span>
    </div>
  );
}

export default ListItemTitle;
